<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page022">
<div class="jstfy" id="page022_1">VEGETABLE STOCK</div>
<div class="jstfy" id="page022_2">B<span class="small1">ouillon de </span>L<span class="small1">égumes</span></div>
<div class="jstfy" id="page022_3">TIME REQUIRED: <span class="page022_3a">2 hours</span></div>
<div class="jstfy" id="page022_4">S<span class="small">tock is an</span> essential ingredient, particularly for vegan cooking.</div>
<div class="jstfy" id="page022_5">1 kg assorted vegetables</div>
<div class="jstfy" id="page022_6">1.</div>
<div class="jstfy" id="page022_6a"><span class="page022_6a"> According to availability and preference, wash, clean and</span></div>
<div class="jstfy" id="page022_7">(onions, carrots, celery,</div>
<div class="jstfy" id="page022_8">coarsely chop the vegetables.</div>
<div class="jstfy" id="page022_9">2.</div>
<div class="jstfy" id="page022_9a"><span class="page022_9a"> Combine with the water in a large pan. Bring to the boil, lower</span></div>
<div class="jstfy" id="page022_10">fennel, etc.)</div>
<div class="jstfy" id="page022_11">the heat, cover and simmer for about 2 hours.</div>
<div class="jstfy" id="page022_12">2 litres water</div>
<div class="jstfy" id="page022_13">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page022_0">22</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_022.vue?6610c69d